export default {
    entryContainer: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    spinnerContainer: {
        display: "flex",
    }
};